import { useRef } from "react";
import { QRCodeSVG } from "qrcode.react";

interface QrCodeProps {
  url: string;
  size?: number;
  allowDownload?: boolean;
  fileName?: string;
}

export default function QrCode({
  url,
  size = 200,
  allowDownload = true,
  fileName = "qr-code",
}: QrCodeProps) {
  const svgRef = useRef<HTMLDivElement>(null);

  const handleDownload = () => {
    if (!allowDownload) return;
    const svgEl = svgRef.current?.querySelector("svg");
    if (!svgEl) return;

    const svgData = new XMLSerializer().serializeToString(svgEl);
    const svgBlob = new Blob([svgData], {
      type: "image/svg+xml;charset=utf-8",
    });
    const url = URL.createObjectURL(svgBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName}.svg`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div
      ref={svgRef}
      onClick={handleDownload}
      style={{
        cursor: allowDownload ? "pointer" : "default",
        display: "inline-block",
      }}
    >
      <QRCodeSVG value={url} size={size} />
    </div>
  );
}
